'use strict';

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _require = require('./api_client'),
    PadletAPIClient = _require.PadletAPIClient;

var _require2 = require('./endpoints'),
    wallEndpoint = _require2.wallEndpoint,
    privacyPolicyEndpoint = _require2.privacyPolicyEndpoint;

var _require3 = require('./contributor'),
    Contributor = _require3.Contributor,
    _searchContributors = _require3.searchContributors;

var _require4 = require('./symbols'),
    permissionToNumberLookup = _require4.permissionToNumberLookup,
    numberToPermissionLookup = _require4.numberToPermissionLookup,
    CAN_READ = _require4.CAN_READ,
    CAN_WRITE = _require4.CAN_WRITE,
    CAN_EDIT = _require4.CAN_EDIT,
    CAN_ADMINISTER = _require4.CAN_ADMINISTER,
    PRIVATE = _require4.PRIVATE,
    PASSWORD_PROTECTED = _require4.PASSWORD_PROTECTED,
    PUBLIC = _require4.PUBLIC,
    SECRET = _require4.SECRET,
    MEMBERS_ONLY = _require4.MEMBERS_ONLY,
    ORGWIDE = _require4.ORGWIDE;

var DEFAULT_CONTRIBUTOR_SEARCH_LIMIT = 5;

var WallPrivacy = function () {
  function WallPrivacy() {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, WallPrivacy);
    this.originalAttributes = attributes;
    this.transientAttributes = (0, _extends3.default)({}, attributes);
    this.client = attributes.client;
  }
  /**
   * Fetch a wall privacy object
   * @param {Object} query - Options to select the privacy policy to fetch.
   * @param {string} query.oauthToken - OAuth token to use to identify the querying user.
   * @param {number/string} query.privacyPolicyId - Optional if `query.wallId` is present.
   * @param {number/string} query.wallId - Optional if `query.privacyPolicyId` is present.
   * @param {Object} query.client - Optional if `query.oauthToken` is present.
   * @param {string} query.host - Optional if `query.client` is present. The host to fetch the wall privacy from.
   * @param {string} query.protocol - Optional if query.client is present. The protocol to fetch the wall privacy from.
   * @returns {Promise} Promise object represents a new WallPrivacy object.
   */


  (0, _createClass3.default)(WallPrivacy, [{
    key: 'searchContributors',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(usernameOrEmail) {
        var _this = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var limit, results;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                limit = options.limit;
                limit = limit || DEFAULT_CONTRIBUTOR_SEARCH_LIMIT;
                _context.next = 4;
                return _searchContributors(this.client, usernameOrEmail, {
                  limit: limit
                });

              case 4:
                results = _context.sent;
                return _context.abrupt('return', (results || []).filter(function (c) {
                  return !_this.isContributorAdded(c);
                }));

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function searchContributors(_x3) {
        return _ref.apply(this, arguments);
      }

      return searchContributors;
    }()
    /**
     * Sends an invitation to an existing contributor to the wall.
     * @param {Contributor} contributor - An existing contributor to the wall.
     * @return {Promise} Resolves to true if invitation was sent. Rejected on error sending.
     */

  }, {
    key: 'resendInvitation',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(contributor) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.isContributorCommitted(contributor)) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('Cannot resend invitation to a contributor that hasn\'t already invited.');

              case 2:
                return _context2.abrupt('return', contributor.resendInvitation({
                  privacyPolicyId: this.privacyPolicyId
                }));

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function resendInvitation(_x4) {
        return _ref2.apply(this, arguments);
      }

      return resendInvitation;
    }()
  }, {
    key: 'discardChanges',
    value: function discardChanges() {
      this.transientAttributes = (0, _extends3.default)({}, this.originalAttributes);
      this._contributors = undefined;
    }
  }, {
    key: 'setDefaultPermission',
    value: function setDefaultPermission() {
      if (!this.permission) {
        this.permission = CAN_READ;
      }
    }
  }, {
    key: 'commit',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var body, result;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.validate();
                body = this.serialize();
                _context3.next = 4;
                return this.client.put(privacyPolicyEndpoint({
                  privacyPolicyId: this.privacyPolicyId
                }), body);

              case 4:
                result = _context3.sent;
                return _context3.abrupt('return', new WallPrivacy((0, _extends3.default)({}, result, {
                  client: this.client
                })));

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function commit() {
        return _ref3.apply(this, arguments);
      }

      return commit;
    }()
  }, {
    key: 'canSetPermission',
    value: function canSetPermission() {
      // const permissionNumber = permissionToNumberLookup(perm)
      // // validate the contributors
      // if (this.contributors.length > 0) {
      // this.contributors.forEach(c => {
      // if (c.right < permissionNumber) {
      // console.warn(
      // `Contributors cannot have permissions lower than everyone else`
      // )
      // return false
      // }
      // })
      // }
      return true;
    }
    /**
     * Check if a particular contributor can be added with a particular permission.
     * As of March 2019, this always returns true, because a contributor with a
     * particular permission should always be allowed on a padlet.
     * @param {Contributor} contributor - Contributor to be added to the padlet.
     * @param {string} permission - Any one of the values in PERMISSIONS object. Can be CAN_READ, CAN_WRITE, CAN_EDIT, CAN_ADMINISTER.
     * @return {boolean} True if can be added. False otherwise.
     */

  }, {
    key: 'canAddContributor',
    value: function canAddContributor(contributor) {
      if (this.isContributorAdded(contributor)) {
        console.warn('Contributor already exists');
        return false;
      }

      return true; // const right = permissionToNumberLookup(permission)
      // if (!this.isContributorAdded(contributor)) {
      // // check if right is valid
      // return right >= permissionToNumberLookup(this.permission)
      // }
      // console.info(`Contributor already exists`)
      // return false
    }
  }, {
    key: 'addContributor',
    value: function addContributor(emailOrUserIdOrContributor, permission) {
      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (!permission) {
        throw new Error('Permission not defined when adding contributor');
      }

      var userId = null;
      var email = null;
      var contributor = null;

      if (emailOrUserIdOrContributor.constructor.name === 'Contributor' || (typeof emailOrUserIdOrContributor === 'undefined' ? 'undefined' : (0, _typeof3.default)(emailOrUserIdOrContributor)) === 'object') {
        contributor = emailOrUserIdOrContributor;
      }

      var name = contributor && contributor.name || extra.name;
      var avatar = contributor && contributor.avatar || extra.avatar;

      if (!contributor) {
        if (emailOrUserIdOrContributor.match(/^\d+$/)) {
          userId = emailOrUserIdOrContributor;
        } else {
          email = emailOrUserIdOrContributor;
        }

        contributor = new Contributor((0, _extends3.default)({}, extra, {
          id: userId,
          right: permissionToNumberLookup(permission),
          email: email,
          name: name,
          avatar: avatar
        }));
      } // Do nothing if contributor already exists


      if (this.isContributorAdded(contributor)) {
        throw new Error('This contributor is already added');
      } else {
        if (this.canAddContributor(contributor)) {
          contributor.permission = permission;
          var existingContributors = this.contributors;
          this.contributors = existingContributors.concat([contributor]);
        } else {
          throw new Error('Cannot add contributor with permission ' + permission);
        }
      } // TODO: validate contributors at this point

    }
  }, {
    key: 'removeContributor',
    value: function removeContributor(emailOrUserIdOrContributor) {
      // Remove by email only works with non-padlet user
      var userId = null;
      var email = null;

      if (emailOrUserIdOrContributor.constructor === Contributor) {
        userId = emailOrUserIdOrContributor.userId;
        email = emailOrUserIdOrContributor.email;
      } else {
        if (emailOrUserIdOrContributor.toString().match(/^\d+/)) {
          userId = emailOrUserIdOrContributor;
        } else {
          email = emailOrUserIdOrContributor;
        }
      }

      this.contributors = this.contributors.filter(function (c) {
        return userId && c.userId !== userId || email && c.email !== email;
      });
    }
  }, {
    key: 'canSetContributorPermission',
    value: function canSetContributorPermission(contributor, permission) {
      if (!this.isContributorAdded(contributor)) {
        console.warn('Contributor not yet added');
        return false;
      }

      if (permissionToNumberLookup(permission) < permissionToNumberLookup(this.permission)) {
        return false;
      }

      return true;
    }
  }, {
    key: 'setContributorPermission',
    value: function setContributorPermission(contributor, permission) {
      contributor.permission = permission;

      if (!this.isContributorAdded(contributor)) {
        console.warn('Contributor not yet added');
      }
    }
  }, {
    key: 'isContributorAdded',
    value: function isContributorAdded(contributor) {
      var isFound = this.contributors.find(function (c) {
        return contributor.email && c.email && c.email === contributor.email || contributor.username && c.username && c.username === contributor.username || contributor.userId && c.userId && c.userId === contributor.userId;
      });
      return !!isFound;
    }
  }, {
    key: 'isContributorCommitted',
    value: function isContributorCommitted(contributor) {
      return this.isContributorAdded(contributor) && !!this.originalAttributes.ausers[contributor.userId];
    }
  }, {
    key: 'isContributorInvited',
    value: function isContributorInvited(contributor) {
      return this.isContributorCommitted(contributor);
    }
  }, {
    key: 'serialize',
    value: function serialize() {
      var serialized = {};

      if (this.isOrgwide || this.isMembersOnly) {
        serialized.tenant_access = permissionToNumberLookup(this.permission);
        serialized.public = 0;
        serialized.public_access = 0;
      } else {
        serialized.public_access = permissionToNumberLookup(this.permission);
        serialized.public = serialized.public_access;
        serialized.tenant_access = 0;
      }

      serialized.password = this.password || null;
      serialized.is_listed = this.isPublic;
      serialized.is_moderated = this.isModerated;
      serialized.ausers = this.serializeContributors();
      return serialized;
    }
  }, {
    key: 'serializeContributors',
    value: function serializeContributors() {
      var ausers = {};
      var all = this.contributors;

      for (var i = 0; i < all.length; i++) {
        var c = all[i];
        ausers[c.userId || c.email] = c.right;
      }

      return ausers;
    }
  }, {
    key: 'validate',
    value: function validate() {
      // Only orgwide padlets can have administer permissions.
      if (this.permission === CAN_ADMINISTER && !this.isOrgwide) {
        throw new Error('Only padlets with organization-wide access can allow all its viewers to administer the padlet.');
      }
    }
  }, {
    key: 'ownerId',
    get: function get() {
      return this.transientAttributes.owner_id;
    }
  }, {
    key: 'wallId',
    get: function get() {
      return this.transientAttributes.wallId;
    }
  }, {
    key: 'privacyPolicyId',
    get: function get() {
      return this.transientAttributes.id;
    }
  }, {
    key: 'isPrivate',
    get: function get() {
      return this.transientAttributes.public === 0 && this.transientAttributes.tenant_access === 0;
    },
    set: function set(newValue) {
      if (newValue === true) {
        this.transientAttributes.is_listed = false;
        this.transientAttributes.public = 0;
        this.transientAttributes.tenant_access = 0;
        this.password = null;
      }
    }
  }, {
    key: 'isPublic',
    get: function get() {
      return this.transientAttributes.public > 0 && this.transientAttributes.is_listed;
    },
    set: function set(newValue) {
      if (newValue === true) {
        if (this.transientAttributes.tenant_access > 0) {
          this.transientAttributes.public = this.transientAttributes.tenant_access;
          this.transientAttributes.tenant_access = 0;
        }

        this.transientAttributes.is_listed = true;
        this.password = null; // Set the default permission

        if (this.transientAttributes.public === 0) {
          this.transientAttributes.public = permissionToNumberLookup(CAN_READ);
        }
      }
    }
  }, {
    key: 'isPasswordProtected',
    get: function get() {
      return this.transientAttributes.password_protected || this.transientAttributes.password !== null && typeof this.transientAttributes.password !== 'undefined' && this.transientAttributes.password !== '' && this.transientAttributes.public > 0;
    },
    set: function set(newValue) {
      if (newValue === true) throw new Error('Set a password');
    }
  }, {
    key: 'isSecret',
    get: function get() {
      return this.transientAttributes.public > 0 && this.transientAttributes.tenant_access === 0 && // is_listed sets as public
      !this.transientAttributes.is_listed && // password protected padlets can also have a
      // non-zero public attribute
      !this.isPasswordProtected;
    },
    set: function set(newValue) {
      if (newValue === true) {
        if (this.transientAttributes.tenant_access > 0) {
          this.transientAttributes.public = this.transientAttributes.tenant_access;
          this.transientAttributes.tenant_access = 0;
        }

        this.transientAttributes.is_listed = false;
        this.password = null;

        if (this.transientAttributes.public === 0) {
          this.transientAttributes.public = permissionToNumberLookup(CAN_READ);
        }
      }
    }
  }, {
    key: 'isTenantwide',
    get: function get() {
      return this.transientAttributes.public === 0 && this.transientAttributes.tenant_access > 0;
    },
    set: function set(newValue) {
      if (newValue === true) {
        if (this.transientAttributes.public > 0 || this.isPasswordProtected) {
          this.transientAttributes.tenant_access = this.transientAttributes.public;
          this.transientAttributes.public = 0;
        }

        this.transientAttributes.is_listed = false;
        this.password = null;

        if (this.transientAttributes.tenant_access === 0) {
          this.transientAttributes.tenant_access = permissionToNumberLookup(CAN_READ);
          this.transientAttributes.public = 0;
        }
      }
    } // Someone is going to make this mistake.
    // We should prepare for it and be permissive.

  }, {
    key: 'isOrgwide',
    get: function get() {
      return this.isTenantwide && this.originalAttributes.tenant_id != 1;
    }
  }, {
    key: 'isMembersOnly',
    get: function get() {
      return this.isTenantwide && this.originalAttributes.tenant_id == 1;
    } // Smeone is going to make this mistake.
    // We should prepare for it and be permissive.

  }, {
    key: 'isOrgWide',
    get: function get() {
      return this.isOrgwide;
    },
    set: function set(newValue) {
      this.isOrgwide = newValue;
    }
  }, {
    key: 'permission',
    get: function get() {
      if (this.isPrivate) {
        return null;
      }

      if (this.isOrgwide || this.isMembersOnly) {
        return numberToPermissionLookup(this.transientAttributes.tenant_access);
      }

      return numberToPermissionLookup(this.transientAttributes.public);
    },
    set: function set(perm) {
      var permissionNumber = permissionToNumberLookup(perm);

      if (!this.canSetPermission()) {
        throw new Error('Invalid permission to be set: ' + perm);
      }

      if (this.isOrgwide || this.isMembersOnly) {
        this.transientAttributes.public = 0;
        this.transientAttributes.tenant_access = permissionNumber;
      } else {
        this.transientAttributes.public = permissionNumber;
        this.tenant_access = 0;
      }
    }
  }, {
    key: 'canRead',
    get: function get() {
      return this.permission === CAN_READ;
    },
    set: function set(newValue) {
      if (newValue === true) this.permission = CAN_READ;
    }
  }, {
    key: 'canWrite',
    get: function get() {
      return this.permission === CAN_WRITE;
    },
    set: function set(newValue) {
      if (newValue === true) this.permission = CAN_WRITE;
    }
  }, {
    key: 'canEdit',
    get: function get() {
      return this.permission === CAN_EDIT;
    },
    set: function set(newValue) {
      if (newValue === true) this.permission = CAN_EDIT;
    }
  }, {
    key: 'canAdminister',
    get: function get() {
      return this.permission === CAN_ADMINISTER;
    },
    set: function set(newValue) {
      if (newValue === true) this.permission = CAN_ADMINISTER;
    }
  }, {
    key: 'isModerated',
    get: function get() {
      return this.transientAttributes.is_moderated;
    },
    set: function set(newValue) {
      this.transientAttributes.is_moderated = newValue;
    }
  }, {
    key: 'password',
    get: function get() {
      return this.transientAttributes.password;
    },
    set: function set(newPassword) {
      this.transientAttributes.password = newPassword;

      if (newPassword && newPassword.trim().length > 0) {
        if (this.transientAttributes.tenant_access > 0) {
          // swap the orgwide setting
          this.transientAttributes.public = this.transientAttributes.tenant_access;
          this.transientAttributes.tenant_access = 0;
        } else if (this.transientAttributes.public === 0) {
          this.transientAttributes.public = permissionToNumberLookup(CAN_READ);
        } else {// public > 0
          // retain the current permission
        }
      } else if (newPassword) {
        // tried to set empty string
        console.warn('Tried to set empty string or whitespace as password');
      }
    }
  }, {
    key: 'contributors',
    get: function get() {
      var _this2 = this;

      if (!this._contributors) {
        this._contributors = (Object.keys(this.transientAttributes.ausers) || []).map(function (userId) {
          var contributorObj = _this2.transientAttributes.ausers[userId] || {};

          if ((typeof contributorObj === 'undefined' ? 'undefined' : (0, _typeof3.default)(contributorObj)) === 'object') {
            return new Contributor((0, _extends3.default)({
              client: _this2.client,
              id: userId
            }, contributorObj));
          } else if (typeof contributorObj === 'number') {
            return new Contributor({
              client: _this2.client,
              id: userId,
              access: contributorObj
            });
          } else if (typeof contributorObj === 'string') {
            return new Contributor({
              client: _this2.client,
              id: userId,
              permission: contributorObj
            });
          }
        });
      }

      return this._contributors;
    },
    set: function set(newContributors) {
      if (!newContributors) {
        console.error('Setting contributors to null or undefined');
        this._contributors = [];
      } else {
        this._contributors = newContributors;
      }
    }
    /**
     * Use to check if any changes have been made to the instance. It registers
     * if a contributor has been added, or if a contributor's permission has changed,
     * or if the privacy setting of the padlet has changed.
     * @return {boolean} True if instance has been changed; false otherwise.
     */

  }, {
    key: 'hasChanges',
    get: function get() {
      var ta = this.transientAttributes;
      var oa = this.originalAttributes;
      var comparableAttributes = ['public', 'tenant_access', 'is_listed', 'is_moderated', 'password']; // NOTE: Using old-school counters because react-native + android
      // has issues dealing with the resulting code. Otherwise we can use
      // for (let a of comparableAttributes) { ... }

      for (var i = 0; i < comparableAttributes.length; i++) {
        var a = comparableAttributes[i];

        if (ta[a] !== oa[a]) {
          return true;
        }
      } // Will also find contributors who don't have user IDs (i.e. contributors that have
      // just been invited by their email address).


      if (this.contributors.length !== Object.keys(oa.ausers || {}).length) {
        return true;
      }

      if (oa.ausers) {
        var contributorUserIds = this.contributors.map(function (c) {
          return c.userId;
        }).filter(function (id) {
          return !!id;
        }).sort();
        var existingContributorUserIds = Object.keys(oa.ausers).sort(); // There's a newly invited contributor that never existed in the system before.

        if (contributorUserIds.length !== existingContributorUserIds.length) {
          return true;
        }

        for (var _i = 0; _i < contributorUserIds.length; _i++) {
          // there isn't an existing contributor like the one that's added
          if (parseInt(contributorUserIds[_i]) !== parseInt(existingContributorUserIds[_i])) {
            return true;
          }
        }

        for (var _i2 = 0; _i2 < this.contributors.length; _i2++) {
          var c = this.contributors[_i2];
          var existing = oa.ausers[c.userId];

          if (!existing) {
            return true;
          } // There's been a change in the permissions for a particular contributor


          if (parseInt(c.right) !== parseInt(existing['access'])) {
            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: 'access',
    get: function get() {
      if (this.isPrivate) {
        return PRIVATE;
      } else if (this.isPasswordProtected) {
        return PASSWORD_PROTECTED;
      } else if (this.isMembersOnly) {
        return MEMBERS_ONLY;
      } else if (this.isOrgwide) {
        return ORGWIDE;
      } else if (this.isSecret) {
        return SECRET;
      } else if (this.isPublic) {
        return PUBLIC;
      } // We shouldn't be coming here, but in case we do, let's be safe.


      return PRIVATE;
    }
  }, {
    key: 'attributes',
    get: function get() {
      return (0, _extends3.default)({}, this.transientAttributes, {
        ownerId: this.ownerId,
        wallId: this.wallId,
        privacyPolicyId: this.privacyPolicyId,
        isPrivate: this.isPrivate,
        isPublic: this.isPublic,
        isMembersOnly: this.isMembersOnly,
        isPasswordProtected: this.isPasswordProtected,
        isSecret: this.isSecret,
        isOrgwide: this.isOrgwide,
        permission: this.permission,
        canRead: this.canRead,
        canWrite: this.canWrite,
        canEdit: this.canEdit,
        canAdminister: this.canAdminister,
        isModerated: this.isModerated,
        password: this.password,
        contributors: this.contributors,
        hasChanges: this.hasChanges,
        access: this.access
      });
    }
  }], [{
    key: 'fetch',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(query) {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', fetchWallPrivacy(query));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetch(_x6) {
        return _ref4.apply(this, arguments);
      }

      return fetch;
    }()
  }]);
  return WallPrivacy;
}();

var DEFAULT_HOST = 'padlet.com';
var DEFAULT_PROTOCOL = 'https';

var fetchWallPrivacy = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(query) {
    var client, oauthToken, csrfToken, padletDomain, protocol, wallId, privacyPolicyId, result, json;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            client = query.client;

            if (!client) {
              oauthToken = query.oauthToken; // this might not be available

              csrfToken = query.csrfToken; // this might not be available

              padletDomain = query.host || DEFAULT_HOST;
              protocol = DEFAULT_PROTOCOL;

              if (query.protocol) {
                protocol = query.protocol;
              } else if (!padletDomain.match(/(\.io|\.com|\.org)$/)) {
                protocol = 'http';
              }

              client = new PadletAPIClient({
                host: padletDomain,
                protocol: protocol,
                oauthToken: oauthToken,
                csrfToken: csrfToken
              });
            }

            wallId = query.wallId;
            privacyPolicyId = query.privacyPolicyId;

            if (!(!wallId && !privacyPolicyId)) {
              _context5.next = 6;
              break;
            }

            throw new Error('Requires wallId or privacyPolicyId to fetch');

          case 6:
            result = null;

            if (!wallId) {
              _context5.next = 12;
              break;
            }

            _context5.next = 10;
            return client.get(wallEndpoint({
              wallId: wallId
            }));

          case 10:
            result = _context5.sent;
            privacyPolicyId = result.privacy_policy.id;

          case 12:
            _context5.next = 14;
            return client.get(privacyPolicyEndpoint({
              privacyPolicyId: privacyPolicyId
            }));

          case 14:
            json = _context5.sent;
            return _context5.abrupt('return', new WallPrivacy((0, _extends3.default)({}, json, {
              client: client
            })));

          case 16:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined);
  }));

  return function fetchWallPrivacy(_x7) {
    return _ref5.apply(this, arguments);
  };
}();

module.exports = {
  WallPrivacy: WallPrivacy,
  fetchWallPrivacy: fetchWallPrivacy
};